import React, { useState } from "react";
import "./RewardsTickHomePage.scss"
import reward from "../image/reward.jpg"
import HeaderText from "../components/Text/HeaderText";
import SubheaderText from "../components/Text/SubheaderText";
import apple from "../image/apple.svg"
import playstore from "../image/playstore.svg"
import PhoneInputComponent from "../components/InputComponent/PhoneInputComponent";
import { isValidPhoneNumber } from 'react-phone-number-input';

const RewardsTickRewardPage = () => {
    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        phone: ""
    })

    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const validateForm = () => {
        let valid = true;

        const newErrors = {
            phone: ""
        };
        const trimmedPhone = phoneNumber.trim();

        if (trimmedPhone === "") {
            newErrors.phone = "*Required";
            valid = false;
        } else if (!isValidPhoneNumber(trimmedPhone)) {
            newErrors.phone = "Please enter a valid phone number";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };
    return (
        <div className="RewardsTickRewardPage">
            <div className="RewardsTickRewardPage-inner">
                <div className="RewardsTickRewardPage-inner-left">
                    <HeaderText
                        text={"Download the App and Enjoy Rewards Everyday!"}
                        invert />
                    <div className="RewardsTickRewardPage-subheader">
                        <SubheaderText
                            text={"Join over 2 million users who are already saving money and earning rewards on every purchase."}
                            invert
                        />
                    </div>
                    <div className="RewardsTickRewardPage-btncont">
                        <div className="RewardsTickRewardPage-down">
                            <img alt="" src={apple} />
                            <div className="RewardsTickRewardPage-down-cont">
                                <div className="RewardsTickRewardPage-down-cont-subheader">
                                    Download on the
                                </div>
                                <div className="RewardsTickRewardPage-down-cont-header">
                                    App Store
                                </div>
                            </div>
                        </div>
                        <div className="RewardsTickRewardPage-down">
                            <img alt="" src={playstore} />
                            <div className="RewardsTickRewardPage-down-cont">
                                <div className="RewardsTickRewardPage-down-cont-subheader">
                                    Get it on
                                </div>
                                <div className="RewardsTickRewardPage-down-cont-header">
                                    Google Play
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="RewardsTickRewardPage-input-cont">
                        <div className="RewardsTickRewardPage-input-cont-text">
                            Or send link to phone:
                        </div>
                        <PhoneInputComponent
                            placeholder={"Enter phone number"}
                            onChange={(e) => {
                                if (e === undefined) {
                                    setPhoneNumber("")
                                } else {
                                    setPhoneNumber(e)
                                }
                                handleChange("phone")

                            }}
                            value={phoneNumber}
                            required
                            error={errors.phone !== ""}
                            errorText={errors.phone} />
                    </div>
                </div>
                <div className="RewardsTickRewardPage-inner-right">
                    <img alt="" src={reward} />
                </div>
            </div>
        </div>
    )
}
export default RewardsTickRewardPage